// export const username = new RegExp('^[A-Za-z0-9_#!%-_*/]*$');
// export const emailId = new RegExp(
//   '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}'
// );
// export const accountingCode = new RegExp('^[A-Za-z0-9 #!%-_*/]*$');
// export const name = new RegExp('^[A-Za-z0-9 _.#!%-_*/]*$');
// export const onlyNumeric = new RegExp('^[0-9]*$');
// export const onlyAlphabets = new RegExp('^[A-Za-z ]*$');
// export const alphaNumericWithSpecialChars = new RegExp('^[A-Za-z0-9 _-]*$');
// export const postCode = new RegExp('^[A-Z0-9a-z]{3} [A-Z0-9a-z]{3}$');
// export const old_mobile = new RegExp('^[0-9]{10}$');
// export const alphaNumericTax = new RegExp('^[A-Za-z0-9 _-_%]*$');
// export const taxRate = new RegExp('^[0-9]{1,2}$');
// export const alphaNumericTaxWithDecimalPoint = new RegExp(
//   '^[A-Za-z0-9 _\\-\\%\\#!%-_*/]*$'
// );
// export const taxRateWithDecimalPoint = new RegExp('^[0-9]*\\.?[0-9]+$');
// // export const mobile = new RegExp('^[0-9]{3}-[0-9]{3}-[0-9]{4}$');
// export const mobile = new RegExp(
//   '^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}(-[0-5]{0,5})?$'
// );

// // export const mobile = new RegExp('^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}(-[0-5]{5})?$');
// export const canadaPostCode = new RegExp(
//   '^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$'
// );
// export const usaPostCode = new RegExp('^[0-9]{5}(-[0-9]{4})?$');
// export const msgSubject = new RegExp('^[A-Za-z0-9 _.@,#!%\\-$_*/]*$');

//--- French entry change
export const username = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9_’'#!%\\-*/]*$");
export const accountingCode = new RegExp(
  "^[A-Za-zÀ-ÖØ-öø-ÿ0-9_’'#!%\\-*/\\s]*$"
);
// export const name = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9_’'#!%\\-*/\\s]*$");
export const name = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9&.,()'’_#%/\\-\\s]+$");
export const emailId = new RegExp(
  "^[A-Za-zÀ-ÖØ-öø-ÿ0-9._%+\\-']+@[A-Za-zÀ-ÖØ-öø-ÿ0-9.-]+\\.[A-Za-zÀ-ÖØ-öø-ÿ]{2,}$"
);

export const onlyNumeric = new RegExp('^[0-9]*$');
export const onlyAlphabets = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ ']*$");
export const alphaNumericWithSpecialChars = new RegExp('^[A-Za-z0-9 _-]*$');
export const postCode = new RegExp(
  '^([0-9]{5}|[A-Za-zÀ-ÖØ-öø-ÿ0-9]{3} [A-Za-zÀ-ÖØ-öø-ÿ0-9]{3})$'
);
export const old_mobile = new RegExp('^[0-9]{10}$');
export const alphaNumericTax = new RegExp('^[A-Za-z0-9 _-_%]*$');
export const taxRate = new RegExp('^[0-9]{1,2}$');
export const alphaNumericTaxWithDecimalPoint = new RegExp(
  '^[A-Za-z0-9 _\\-\\%\\#!%-_*/]*$'
);
export const taxRateWithDecimalPoint = new RegExp('^[0-9]*\\.?[0-9]+$');
// export const mobile = new RegExp('^[0-9]{3}-[0-9]{3}-[0-9]{4}$');
export const mobile = new RegExp(
  '^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}(-[0-5]{0,5})?$'
);
// export const mobile = new RegExp('^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}(-[0-5]{5})?$');
export const canadaPostCode = new RegExp(
  '^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$'
);
export const usaPostCode = new RegExp('^[0-9]{5}(-[0-9]{4})?$');
export const msgSubject = new RegExp('^[A-Za-zÀ-ÖØ-öø-ÿ0-9 _.@,#!%\\-$_*/]*$');
